// GET_PLATFORM_CONFIG
export const GET_PLATFORM_CONFIG = "GET_PLATFORM_CONFIG";
export const GET_PLATFORM_CONFIG_SUCCESS = "GET_PLATFORM_CONFIG_success";
export const GET_PLATFORM_CONFIG_FAILURE = "GET_PLATFORM_CONFIG_failure";
